export default "__VITE_ASSET__DsvN44fD__"